import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export class ContractorsSearchRequest extends GenericRequest {

    term;
    allCompanies;

    constructor(term, allCompanies = true) {
        super(METHOD_POST, ApiEndpoints.COMPANIES);
        this.term = term;
        this.allCompanies = allCompanies;
    }

    overrideRequest() {
        return {
            retrieve_document_stats: false,
            criteria: {
                term: this.term,
                page: 1,
                only_active: false,
                only_inactive: false,
                show_only_deleted: false,
                show_all_companies: this.allCompanies,
            },
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/contractors/ws/ContractorsSearchRequest.js